import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert, useAxios } from "../../hooks";
import React from "react";
import { styled } from "@mui/material/styles";
import {
  Dialog,
  DialogContent,
  Typography,
  Grid,
  Box,
  Button,
} from "@mui/material";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "../../components";
import { useDispatch } from "react-redux";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: "15px",
    background: "#fff",
    overflow: "hidden",
    [theme.breakpoints.up("sm")]: {
      width: "85%",
    },
    [theme.breakpoints.up("md")]: {
      width: "50%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "35%",
    },
  },
}));

const HeaderBox = styled(Box)(({ color }) => ({
  background: color,
  padding: "25px 20px 30px",
  textAlign: "center",
  position: "relative",
}));

const ContentBox = styled(Box)(({ theme }) => ({
  padding: "20px",
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    padding: "16px",
  },
}));

function UserStatus({ userStatus, setUserStatus, setUserData, userData }) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const { alert } = useAlert();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const maskPhone = (phone) => {
    if (!phone) return "";
    return phone.replace(/.(?=.{4})/g, "*");
  };

  function handleDeleteData() {
    setLoading(true);

    axios({
      url: "event/verify/delete-face",
      data: { visitor_id: userData?.visitor_id, is_visitor_delete: false },
      method: "POST",
    }).then((resp) => {
      if (resp.status) {
        setUserStatus(false);
        // setUserData({});
        navigate(userData?.journey_status.page_link);
        dispatch(
          alert({
            type: "success",
            message: resp?.message?.displayMessage,
          })
        );
      } else {
        dispatch(
          alert({
            type: "error",
            message: resp?.message?.displayMessage,
          })
        );
      }
      setLoading(false);
    });
  }

  return (
    <StyledDialog open={userStatus} fullWidth maxWidth="sm">
      <>
        <HeaderBox color="#d71111ff">
          <ErrorIcon sx={{ fontSize: "55px", color: "#fff" }} />
          <Typography variant="h5" fontWeight={700} color="white" mt={2}>
            Verification Already Done
          </Typography>
        </HeaderBox>

        <DialogContent>
          <ContentBox>
            <Grid item xs={12}>
              <Typography variant="body1" fontWeight={500} mt={2}>
                You already completed your verification from this browser{" "}
                <strong>{userData?.browser_data || "User"}</strong>. Kindly give
                consent from this browser.
              </Typography>
              <Typography variant="body1" fontWeight={500} mt={1}>
                If you want to start verification again, press the button below.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <LoadingButton
                id="restart-verification"
                type="button"
                loading={loading}
                onClick={() => {
                  handleDeleteData?.();
                }}
                style={{
                  padding: "10px 45px",
                  width: "95%",
                  boxShadow: "none",
                  marginTop: "20px",
                }}
              >
                Start Verification Again
              </LoadingButton>
            </Grid>
          </ContentBox>
        </DialogContent>
      </>
    </StyledDialog>
  );
}

export default UserStatus;
